import {Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChildren} from '@angular/core';
import {paramsHelper} from "../../helpers/params-helper";
import {DOCUMENT_TYPES, VALUE_TYPE} from "../../enums/enums";
import {localeUtils} from "../../helpers/locale-utils";
import {UI_TEXTS} from "../../enums/e-texts";
import {IDocument} from "../../interfaces/document.definition";
import {BusService, INewDocumentEvent} from "../../services/bus.service";
import {ISearchItem} from "../../definitions";
import {SEARCH_PROP_TYPES} from "../../enums/e-search";
import {CollectionService} from "../../services/collection.service";
import {Subject} from "rxjs/Subject";
import {createObjectLink, createObjectLinkQuery} from "../../helpers/create-object-link";
import {NvDocControlsComponent} from "../../components/nv-doc-controls/nv-doc-controls.component";
import {NvPageComponent} from "../../components/nv-page/nv-page.component";
import {GO_CATEGORIES} from "../../enums/e-game-objects";
import {inputUtils} from "../../helpers/input-utils";
import {FactoryService} from "../../services/factory.service";
import {JP} from "../../helpers/jp";
import {WatchService} from "../../services/watch.service";

@Component({
  templateUrl: './offer-lots.premium-shop-page.component.html'
})
export class OfferLotsComponent implements OnInit, OnDestroy {
  UI_TEXTS = UI_TEXTS;
  VALUE_TYPE = VALUE_TYPE;
  GO_CATEGORIES = GO_CATEGORIES;

  pageParams = paramsHelper.page()
    .setTitle("Магазин премиум валюты - Лоты для офферов");

  private unsubscribe: Subject<void> = new Subject<void>();

  collectionParams = paramsHelper.collection()
    .setObjectType(DOCUMENT_TYPES.OFFER_LOTS)
    .setDefaultListLabels()
    .setItemLabelQuery(`locales.${localeUtils.getLocale()}[key=name].value.0`)
    .setSearchParams(paramsHelper.search()
      .addNumberParam("id"));

  document: IDocument;

  linkedOffers:Array<ISearchItem>;

  constructor(private busService:BusService,
              private collectionService:CollectionService,
              protected factoryService: FactoryService,
              private watchService: WatchService) { }

  ngOnInit() {
    this.busService.onDocumentUpdated
      .takeUntil(this.unsubscribe)
      .subscribe(
        e => this.onDocumentUpdated(e));
  }

  ngOnDestroy(){
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  private onDocumentUpdated(e: INewDocumentEvent) {
    this.document = e.document;

    if (this.document) {
      inputUtils.initializeArrayIfMissing(this.document, "/rewardSlots");
      this.loadLinkedOffers();
    }
  }

  private loadLinkedOffers()
  {
    this.linkedOffers = [];

    const searchParams = paramsHelper.search()
      .addParam("_type", SEARCH_PROP_TYPES.STRING, DOCUMENT_TYPES.OFFER)
      .addParam("lotsIds", SEARCH_PROP_TYPES.NUMBER, this.document.id)
      .json;

    const params = paramsHelper.loader()
      .setEndpointApi()
      .setAdditionalParam("filter", { id: 1, _type: 1, category: 1, locales: 1})
      .setSearchParams(searchParams);

    this.collectionService.search(params)
      .subscribe(
        r => {
          this.linkedOffers = r;
          if (this.linkedOffers.length == 0)
          {
            this.pageParams.setOnDeleteMessage("");
          }
          else
          {
            this.pageParams.setOnDeleteMessage("Не удалить! Привязан к офферам.");
          }
        });
  }

  createOfferLink(offer:ISearchItem):string[] {
    return createObjectLink(offer);
  }

  createOfferLinkQuery(offer:ISearchItem):any {
    return createObjectLinkQuery(offer);
  }

  getOfferName(offer:ISearchItem):string {
    return offer ? offer.locales ? localeUtils.findName(offer): 'NO NAME' : "MISSING";
  }

  onAddSlotClick(){
    this.factoryService.addRewardSlotTo(this.document);
  }

  getRewardSlots(){
    var slots = JP.get(this.document, "/rewardSlots");
    return slots;
  }

  onRemoved() {
      this.watchService.notify();
  }

}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/pages/prem_shop/offer-lots.premium-shop-page.component.ts